import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Application } from "@faire/web/slate/icons/foundation/Application";
import React from "react";
import { BulkDownloadIA } from "../instantAnswers/invoicesAndPayments-bulkDownload";
import { InvoiceBasicsIA } from "../instantAnswers/invoicesAndPayments-invoiceBasics";
import { WhereToFindInvoicesL3IA } from "../instantAnswers/invoicesAndPayments-whereToFindInvoicesL3";
export var useInvoicesRetailerNodes = function useInvoicesRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Invoices: {
      id: "Invoices",
      label: strictLocalize({
        id: "/WeEo7",
        defaultMessage: [{
          "type": 0,
          "value": "Facturen"
        }]
      }),
      icon: /*#__PURE__*/React.createElement(Application, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["AboutInvoices", "HowToFindAnInvoice", "DownloadInvoices"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "TIqea1",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met facturen"
        }]
      })
    },
    HowToFindAnInvoice: {
      id: "HowToFindAnInvoice",
      label: strictLocalize({
        id: "MW6Wdq",
        defaultMessage: [{
          "type": 0,
          "value": "Zo vind je een factuur"
        }]
      }),
      instantAnswer: WhereToFindInvoicesL3IA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 3
    },
    DownloadInvoices: {
      id: "DownloadInvoices",
      label: strictLocalize({
        id: "oRK+YO",
        defaultMessage: [{
          "type": 0,
          "value": "Facturen downloaden"
        }]
      }),
      instantAnswer: BulkDownloadIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 3
    },
    AboutInvoices: {
      id: "AboutInvoices",
      label: strictLocalize({
        id: "t0gXSt",
        defaultMessage: [{
          "type": 0,
          "value": "Over facturen"
        }]
      }),
      instantAnswer: InvoiceBasicsIA(strictLocalize),
      articles: [articles.PaymentsAndInvoices.UNDERSTANDING_ORDER_INVOICE],
      level: 2
    }
  };
};